import { createApiUrl } from './shareLinkService';

/**
 * Speichert die geplante Tour auf dem Server und liefert den dauerhaften Prüf-Link.
 * Gleicher tourKey → gleicher Link (spätere Änderungen aktualisieren die Tour).
 */
export const publishTourLink = async ({ tourKey, tourName, tourDate, payload }) => {
  const response = await fetch(createApiUrl('api/tours'), {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ tourId: tourKey, tourName, tourDate, payload }),
  });
  if (!response.ok) throw new Error(`Tour-Link konnte nicht erstellt werden (${response.status})`);
  return (await response.json()).url;
};

export const fetchPublicTour = async (token) => {
  const response = await fetch(createApiUrl(`api/public/tours/${token}`));
  if (!response.ok) throw new Error(response.status === 404 ? 'Tour nicht gefunden' : 'Tour konnte nicht geladen werden');
  return response.json();
};
